module.exports = __webpack_public_path__ + "static/media/heart-cropped.b95bb342.svg";